import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';

interface PyramidData {
  name: string;
  value: number;
  color?: string;
}

interface PyramidChartProps {
  data: PyramidData[];
  className?: string;
}

const PyramidChart: React.FC<PyramidChartProps> = ({ data, className = '' }) => {
  const option = useMemo(() => {
    const sortedData = [...data].sort((a, b) => b.value - a.value);
    
    return {
      backgroundColor: '#ffffff',
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        top: '10%',
        containLabel: true
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderColor: '#e5e7eb',
        textStyle: { color: '#1f2937' }
      },
      series: [
        {
          name: 'Pyramid',
          type: 'funnel',
          left: '10%',
          top: '10%',
          width: '80%',
          height: '80%',
          minSize: '0%',
          maxSize: '100%',
          sort: 'descending',
          gap: 2,
          label: {
            show: true,
            position: 'inside',
            fontSize: 12,
            color: '#1f2937',
            formatter: '{b}'
          },
          labelLine: {
            length: 10,
            lineStyle: {
              width: 1,
              type: 'solid'
            }
          },
          itemStyle: {
            borderColor: '#1a1a1a',
            borderWidth: 1
          },
          emphasis: {
            label: {
              fontSize: 14,
              fontWeight: 'bold'
            },
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          data: sortedData.map((item, index) => ({
            name: item.name,
            value: item.value,
            itemStyle: {
              color: item.color || [
                '#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6'
              ][index % 5]
            }
          }))
        }
      ]
    };
  }, [data]);

  return (
    <ReactECharts
      option={option}
      style={{ height: '100%', width: '100%' }}
      className={className}
      opts={{ renderer: 'canvas' }}
    />
  );
};

export default PyramidChart;